import { Language } from '../custom-types';

export default function linkToSlug({
  language,
  slug,
  defaultLanguage,
}: {
  language?: string | undefined | Language;
  slug?: string | null;
  defaultLanguage: string;
}): string {
  if (language && language !== defaultLanguage) return `/${language}${slug ? '/' : ''}${slug ? slug : ''}`;
  else return `/${slug ? slug : ''}`;
}
